import React, { useState, useEffect } from "react";
import { Eye, HeartHandshake, Users } from "lucide-react";

export default function Nosotros() {

  // Carrusel automático
  const imagenes = [
    "/images/nosotros1.jpg",
    "/images/nosotros2.jpg",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % imagenes.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="nosotros"
      className="scroll-mt-32 py-20 bg-white border-t"
    >
      <div className="max-w-6xl mx-auto px-6">

        {/* Título */}
        <h2 className="text-4xl font-bold text-center text-blue-900 mb-12">
          Sobre Nosotros
        </h2>

        {/* Grid principal */}
        <div className="grid md:grid-cols-2 gap-12 items-center">

          {/* ✅ Carrusel corregido */}
          <div className="rounded-3xl overflow-hidden shadow-lg w-full">
            <div className="relative w-full h-[280px] sm:h-[420px] bg-gray-100">
              {imagenes.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`Nosotros ${i}`}
                  className={`absolute inset-0 w-full h-full
                    object-contain sm:object-cover
                    transition-opacity duration-[1200ms]
                    ${i === index ? "opacity-100" : "opacity-0"}
                  `}
                />
              ))}
            </div>
          </div>

          {/* Texto */}
          <div>
            <h3 className="text-3xl font-semibold text-blue-800 mb-4 text-center">
              Brindando excelencia en salud visual
            </h3>

            <p className="text-gray-700 leading-relaxed mb-6 text-justify">
              Somos una empresa dedicada a ofrecer soluciones ópticas y equipos especializados
              para clínicas, hospitales y profesionales de la salud visual. Nuestro compromiso
              es garantizar la mejor calidad, precisión y confiabilidad en cada producto.
            </p>

            {/* Valores */}
            <div className="space-y-6">

              {/* Misión */}
              <div className="flex items-start gap-4">
                <Eye size={32} className="text-blue-900 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-lg text-left">Misión</h4>
                  <p className="text-gray-600 text-justify">
                    Brindar atención médica integral y humana con diagnósticos confiables
                    y especializados incluyendo nuestra óptica en Medicentro La Esperanza,
                    para mejorar la salud visual de nuestros clientes.
                  </p>
                </div>
              </div>

              {/* Visión */}
              <div className="flex items-start gap-4">
                <HeartHandshake size={32} className="text-blue-900 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-lg text-left">Visión</h4>
                  <p className="text-gray-600 text-justify">
                    Ser una clínica reconocida por su excelencia, trato humano y servicios integrales para la salud,
                    fortaleciendo nuestras áreas médicas y la óptica como principal crecimiento.
                  </p>
                </div>
              </div>

              {/* Valores */}
              <div className="flex items-start gap-4">
                <Users size={32} className="text-blue-900 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-lg text-left">Valores</h4>
                  <p className="text-gray-600 text-justify">
                    Ética profesional, compromiso, excelencia, honestidad y atención profesional en cada paso.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
